// src/components/shared/LoadingSpinner.js
import React from 'react';
import styled, { keyframes } from 'styled-components';

const spin = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;

const Spinner = styled.div`
  border: 8px solid ${(props) => props.theme.colors.textSecondary};  /* Light grey */
  border-top: 8px solid ${(props) => props.theme.colors.primary};  /* Blue */
  border-radius: 50%;
  width: 50px;
  height: 50px;
  animation: ${spin} 1s linear infinite;
  margin: 100px auto;
`;

const LoadingSpinner = () => {
  return <Spinner />;
};

export default LoadingSpinner;
